(async function () {
  await import('./bootstrap');
})();

export {};
